import { all, fork, take } from "redux-saga/effects";
import masterDataSaga from "./masterData/saga";
import dashboardSaga from "./dashboard/saga";
import activitySagas from "./activityLogs/saga";
import userSaga from "./users/saga";
import configurationSaga from "./configuration/saga";
import ltlCustomerSaga from "./ltlCustomers/saga";
import invoicesSaga from "./invoicesEntry/saga";
import customersVendorsSaga from "./customersVendors/saga";
import { RESET_ON_LOGOUT } from "./users/actionTypes";
import piaggioCustomerSaga from "./piaggioCustomers/saga";
import piaggioItemDetailsSaga from "./piaggioItemDetails/saga";
import lozierStoreSaga from "./lozierStore/saga";
import allCustomersVendorsSaga from "./allCustomersVendors/saga";
import allUsersSaga from "./allUsers/saga";
import ecolabItemDetailsSaga from "./ecolabItemDetails/saga";
import podDocumentSaga from "./podDocument/saga";
import cardtronicsSaga from "./cardtronicsCustomers/saga";
import hpeSaga from "./hpeCustomers/saga";
import calixNetworksSaga from "./calixNetworksCustomers/saga";
import nautilusItemDetailsSaga from "./nautilusItemDetails/saga";
import { settingsSaga } from "./settings/saga";
import carrierTrackingSaga from "./carrierTracking/saga";

export function* rootSaga() {
  yield all([
    fork(masterDataSaga),
    fork(dashboardSaga),
    fork(activitySagas),
    fork(userSaga),
    fork(configurationSaga),
    fork(ltlCustomerSaga),
    fork(invoicesSaga),
    fork(customersVendorsSaga),
    fork(allCustomersVendorsSaga),
    fork(piaggioCustomerSaga),
    fork(piaggioItemDetailsSaga),
    fork(ecolabItemDetailsSaga),
    fork(lozierStoreSaga),
    fork(allUsersSaga),
    fork(podDocumentSaga),
    fork(cardtronicsSaga),
    fork(hpeSaga),
    fork(calixNetworksSaga),
    fork(nautilusItemDetailsSaga),
    fork(settingsSaga),
    fork(carrierTrackingSaga),
  ]);
  yield take(RESET_ON_LOGOUT);
}
